import constants from '@/util/constants.js'
import { infraMixin } from '@/modules/infra/mixins'
import util from '@/util'
import mensagens from '@/util/mensagens.js'
export default {
  props: {
    foto: null,
    nome: '',
    email: '',
    idCliente: null,
    permitido: {
      type: Boolean,
      default: true
    },
    tipo: {
      type: String,
      default: ''
    },
    abaCliente: {
      type: Boolean,
      default: false
    },
    image64: null
  },
  mixins: [infraMixin],
  methods: {
    async acessarCliente () {
      this.$emit('acessar-cliente', this.idCliente)
      if (this.permitido && this.tipo === 'cliente' && this.abaCliente === true) {
        this.acessarSistemaExterno(constants.urlSistemaExterno.juridico + '?idCliente=' + this.idCliente)
      } else if (this.permitido && this.tipo === 'usuario') {
        return false
      } else {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.acessoNegado)
      }
    },

    async acessarSistemaExterno (urlSistema, abrirEmNovaJanela = true) {
      await this.redirecionarParaSistemaExterno(urlSistema, abrirEmNovaJanela)
    }
  }
}
